import { createFileRoute } from '@tanstack/react-router';
import { useLingui } from '@lingui/react/macro';
import { PageSeo } from './-components/page-seo';
import { slugs } from './contact.meta';

/**
 * The audience-less Contact page: the visitor is asked who they are, and each answer is a child page.
 *
 * It stays a chooser rather than redirecting to a default questionnaire. Every generic "Contact us" on
 * the site points here — the header, the mobile menu, the footer's nav, the FAQ's closing block — and a
 * default would file all of them under one category, which is the failure TEC-3821 B13 recorded from
 * the other direction. It is also the hand-off's own first step, and the URL `www` has always indexed.
 */
export const Route = createFileRoute('/www/contact/')({
	component: Component,
});

function Component() {
	const { t } = useLingui();

	return (
		<PageSeo
			slugs={slugs}
			title={t`Contact - Worldcoo`}
			description={t`If you'd like to incorporate Charity Rounding Up, if you're a social entity, or if you'd like some more information, please contact us.`}
		/>
	);
}
